import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
}
export const fetchAllAbout = createAsyncThunk(
    "fetchAllAbout",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/about/fetch-all-about?page=${body.page}&search=${body.search}`);
            return response.data;

        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)



export const AboutSlice = createSlice({
    name: 'AboutSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAllAbout.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchAllAbout.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload
            state.count = action?.payload?.count;
        })
        builder.addCase(fetchAllAbout.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        // builder.addCase(fetchSinglePurchasedProperty.pending, (state, action) => {
        //     state.loading = true;
        //     state.singlePurPro = null;
        // })
        // builder.addCase(fetchSinglePurchasedProperty.fulfilled, (state, action) => {
        //     state.loading = false;
        //     state.singlePurPro = action.payload;
        // })
        // builder.addCase(fetchSinglePurchasedProperty.rejected, (state, action) => {
        //     state.loading = false;
        //     state.error = action.payload?.data;
        // });

    },

})

export default AboutSlice.reducer;